<assets-handler [assetType]="props['assetType']"
                [accept]="props['accept']"
                [source]="formControl.value"
                [multiple]="props['multiple']"
                (changed)="handleChanges($event)" />
